import React from 'react'
import { CobuText, CobuCard, CobuStack } from '@cobu/ui'

type ProfileSectionProps = {
  title: string
  children: React.ReactNode
}

export default function ProfileSection({ title, children }: ProfileSectionProps) {
  const childrenArray = React.Children.toArray(children)
  const lastIndex = childrenArray.length - 1

  return (
    <CobuStack>
      <CobuStack
        backgroundColor="$backgroundSecondary"
        paddingTop="$4"
        paddingBottom="$2"
        paddingHorizontal="$2"
      >
        <CobuText color="$colorMuted" textTransform="uppercase" letterSpacing={1}>
          {title}
        </CobuText>
      </CobuStack>

      <CobuCard padding="$0" backgroundColor="$background" borderWidth={0}>
        <CobuStack>
          {childrenArray.map((child, index) =>
            React.cloneElement(child as React.ReactElement, {
              isFirstItem: index === 0,
              isLastItem: index === lastIndex,
              key: index,
            })
          )}
        </CobuStack>
      </CobuCard>
    </CobuStack>
  )
}


